<dgx-profile-heading
  *ngIf="!isPageLoading"
  [heading]="'UserController_Achievements' | translate"
  [hasItems]="!isEmpty"
  [viewAllUrl]="collectionUrl"
  [viewAllUrlQueryParams]="viewAllUrlQueryParams"
  [showViewAll]="showViewAll"
  [ownerIsViewing]="ownerIsViewing"
  [isMobile]="isMobile"
>
  <dgx-add-menu
    #addMenuButton
    *ngIf="ownerIsViewing && showAdd"
    [menuConfig]="menuConfig"
    [ariaLabel]="i18n.dgProfileOverview_AddAchievements"
  ></dgx-add-menu>
</dgx-profile-heading>

<dgx-profile-card-carousel
  [emptyTileCount]="emptyTiles"
  *ngIf="!isEmpty && useCarousel && !isPageLoading && !isMobile"
>
  <ng-container
    *ngFor="
      let achievement of achievements;
      trackBy: trackByCollectionId;
      let last = last;
      index as achievementIndex
    "
    data-dgat="achievements-037"
  >
    <ng-container
      *ngTemplateOutlet="
        achievementCard;
        context: { achievement: achievement, last: true }
      "
    ></ng-container>
  </ng-container>
</dgx-profile-card-carousel>

<div
  *ngIf="!isEmpty && useCarousel && !isPageLoading && isMobile"
  class="l_flex m-l_flex l_flex-column l_flex-middle m-l_flex-middle"
>
  <div
    *ngFor="let achievement of achievements; let last = last"
    class="guts-p-b-2"
  >
    <ng-container
      *ngTemplateOutlet="
        achievementCard;
        context: { achievement: achievement, last: last }
      "
    ></ng-container>
  </div>
</div>

<div *ngIf="!isEmpty && !useCarousel && !isPageLoading">
  <div class="grid overview-carousel-container">
    <div
      class="grid__col-12 grid__col--bleed"
      [ngClass]="{ os: isMobile, clear: !isMobile }"
    >
      <ul
        class="grid grid--justify-space-between m-guts-p-l-half"
        [ngClass]="{ 'l_flex-wrap': !isMobile }"
      >
        <li
          *ngFor="
            let achievement of achievements;
            trackBy: trackByCollectionId;
            let last = last;
            index as achievementIndex
          "
          data-dgat="achievements-037"
          class="guts-p-l-0 grid__col-xs-6 auto-width m-guts-m-r-1"
          [class.guts-p-r-0]="
            !isMobile && (achievementIndex + 1) % cardRowLimit === 0
          "
        >
          <ng-container
            *ngTemplateOutlet="
              achievementCard;
              context: { achievement: achievement, last: last }
            "
          ></ng-container>
        </li>
        <li
          *ngFor="let count of emptyTiles; let last = last"
          class="empty-achievements-tile guts-m-v-1-half guts-m-r-1-half"
          [class.guts-m-r-0]="last"
          data-dgat="achievements-187"
        ></li>
      </ul>
      <div
        *ngIf="pageType === 'Achievements' && hasMoreItems"
        class="center-text no-mobile"
      >
        <button
          df-button
          dfButtonType="passive"
          class="show-more-btn"
          (click)="loadMoreAchievements(currentEndIndex)"
          data-dgat="achievements-972"
        >
          <df-spinner-button [isSpinning]="sectionLoading">
            {{ 'Core_ShowMore' | translate }}
          </df-spinner-button>
        </button>
      </div>

      <div *ngIf="sectionLoading" class="l_flex">
        <dgx-skeleton
          type="userOutcome"
          class="grid__col-md-3 guts-p-l-0 m-guts-p-full-0"
        ></dgx-skeleton>
        <dgx-skeleton
          type="userOutcome"
          class="grid__col-md-3 no-mobile"
        ></dgx-skeleton>
        <dgx-skeleton
          type="userOutcome"
          class="grid__col-md-3 no-mobile guts-p-r-0"
        ></dgx-skeleton>
        <dgx-skeleton
          type="userOutcome"
          class="grid__col-md-3 no-mobile guts-p-r-0"
        ></dgx-skeleton>
      </div>

      <div *ngIf="useShowMore && hasMoreItems" class="center-text no-mobile">
        <button
          df-button
          dfButtonType="passive"
          class="show-more-btn"
          (click)="loadMoreAchievements(currentEndIndex)"
          data-dgat="achievements-972"
        >
          <df-spinner-button [isSpinning]="sectionLoading">
            {{ 'Core_ShowMore' | translate }}
          </df-spinner-button>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isPageLoading && useLoadingTemplate">
  <div class="guts-p-t-1-half">
    <dgx-skeleton type="mediumTitle"></dgx-skeleton>
    <div class="l_flex">
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 guts-p-l-0 m-guts-p-v-1-half m-guts-p-r-0"
      ></dgx-skeleton>
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 no-mobile"
      ></dgx-skeleton>
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 no-mobile"
      ></dgx-skeleton>
      <dgx-skeleton
        type="verticalBlock"
        class="grid__col-md-3 no-mobile guts-p-r-0"
      ></dgx-skeleton>
    </div>
  </div>
</div>

<ng-template #achievementCard let-last="last" let-achievement="achievement">
  <div
    [ngClass]="{
      'guts-m-r-3':
        (!last || achievements.length < achievementDisplayLimit) &&
        useCarousel &&
        !isMobile,
      'guts-m-r-half': achievements.length === achievementDisplayLimit
    }"
  >
    <dgx-user-outcome-tile-v2
      [userOutcome]="achievement"
      [owner]="profile"
      [showSelectOption]="false"
    ></dgx-user-outcome-tile-v2>
  </div>
</ng-template>

<div *ngIf="isEmpty && !isPageLoading" class="guts-m-b-1-half">
  <dgx-profile-section-empty-state [ownerIsViewing]="ownerIsViewing && showAdd">
    <dgx-add-menu
      [menuConfig]="menuConfig"
      [linkText]="i18n.dgProfileOverview_AddAchievements"
    ></dgx-add-menu>
  </dgx-profile-section-empty-state>
</div>
